import React, { useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, TextField, Typography } from '@mui/material';
import { Company, CompanyNote } from '../../types';
import { apiClient } from '../../services/api';

interface Props { open: boolean; company: Company | null; onClose: () => void; onSaved: () => void; }

const CompanyNoteDialog: React.FC<Props> = ({ open, company, onClose, onSaved }) => {
  const [notes, setNotes] = useState<CompanyNote[]>([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !company) return;
    setLoading(true); setError(null); setNote('');
    apiClient.getCompanyNotes(company.id).then(setNotes).catch(() => setError('Not geçmişi yüklenemedi.')).finally(() => setLoading(false));
  }, [open, company]);

  const save = async () => {
    if (!company || !note.trim()) return;
    setSaving(true); setError(null);
    try {
      const created = await apiClient.addCompanyNote(company.id, note.trim());
      setNotes(previous => [created, ...previous]); setNote(''); onSaved();
    } catch { setError('Not eklenemedi.'); } finally { setSaving(false); }
  };

  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{company?.name} — Görüşme notları</DialogTitle>
    <DialogContent>
      <Stack spacing={2} sx={{ pt: 1 }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Yeni not" multiline minRows={3} value={note} onChange={event => setNote(event.target.value)} disabled={saving} fullWidth inputProps={{ maxLength: 4000 }} />
        <Button variant="contained" onClick={() => { void save(); }} disabled={saving || !note.trim()}>Not ekle</Button>
        <Divider />
        {loading ? <Typography color="text.secondary">Yükleniyor…</Typography> : notes.length === 0 ? <Typography color="text.secondary">Henüz not yok.</Typography> : notes.map(item => <Stack key={item.id} spacing={0.5}>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{item.note}</Typography>
          <Typography variant="caption" color="text.secondary">{item.createdByUsername} · {new Date(item.createdAt).toLocaleString('tr-TR')}</Typography>
        </Stack>)}
      </Stack>
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Kapat</Button></DialogActions>
  </Dialog>;
};

export default CompanyNoteDialog;
